// extracted by mini-css-extract-plugin
export var link = "hs_R";